module.exports = __webpack_public_path__ + "static/media/oraBg.2a989a94.png";